import StartTrackingCard from "../widgets/StartTracking/StartTrackingCard";
import PendingReferralsCard from "../widgets/PendingReferrals/PendingReferralsCard";
import KeyInsightsCard from "../widgets/KeyInsights/KeyInsightsCard";
import HCPGrowersCard from "../widgets/HCPGrowers/HCPGrowersCard";
import TerritoryPerformance from "../widgets/TerritoryPerformance/TerritoryPerformance";
import DeNovoCard from "../widgets/DeNovo/DeNovoCard";
import KPIAlertTrackingCard from "../widgets/KPIAlertTracking/KPIAlertTrackingCard";
import RegionTrackingCard from "../widgets/RegionTracking/RegionTrackingCard";
import RegionalPerformanceCard from "../widgets/RegionalPerformance/RegionalPerformanceCard";
import ReachAndFrequencyCard from "../widgets/ReachAndFrequency/ReachAndFrequencyCard";
import TopYutrepiaWritersCard from "../widgets/TopYutrepiaWriters/TopYutrepiaWritersCard";
import TreatmentRateWidget from "../../widgets/TreatmentRateWidget";
import { TREATMENT_RATE_WIDGET_TEXT } from "../../widgets/treatmentRateTextConstants";
import HcpHcoAccountChangesCard from "../widgets/HcpHcoAccountChanges/HcpHcoAccountChangesCard";
import TyvasoDpiDosageDistributionCard from "../widgets/TyvasoDpiDosageDistribution/TyvasoDpiDosageDistributionCard";
import TyvasoDpiDosageNotificationCard from "../widgets/TyvasoDpiDosageNotification/TyvasoDpiDosageNotificationCard";
import {
  NationalPerformanceTile,
  RegionalTerritoryPerformanceTile,
  InsightPatientTrendsTile,
  InsightPhysicianBehaviorTile,
  InsightUtEngagementTile,
  InsightCompetitorDynamicsTile,
} from "./SalesRepMyPerformanceTabTileWidgets";

// MUI icons (pick what matches your widgets)
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import DonutSmallOutlinedIcon from "@mui/icons-material/DonutSmallOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";

export const WIDGETS = {
  startTracking: {
    title: "Start Tracking",
    subtitle: "Goal progress and benchmarks",
    icon: DonutSmallOutlinedIcon,
    component: StartTrackingCard,
  },

  pendingReferrals: {
    title: "Pending Referrals",
    subtitle: "Pending tasks and to-dos",
    icon: ChecklistOutlinedIcon,
    component: PendingReferralsCard,
  },
  keyInsights: {
    title: "Key Insights",
    subtitle: "Trends and key indicators",
    icon: InsightsOutlinedIcon,
    component: KeyInsightsCard,
  },
  hcpGrowers: {
    title: "HCP Growers / Decliners",
    subtitle: "Growth up/down list",
    icon: TrendingUpOutlinedIcon,
    component: HCPGrowersCard,
  },

  regionalPerformance: {
    title: "Region Performance",
    subtitle: "Region-level performance snapshot",
    icon: BarChartOutlinedIcon,
    component: RegionalPerformanceCard,
  },
  territoryPerformance: {
    title: "Territory Performance",
    subtitle: "Sent vs. received over time",
    icon: ShowChartOutlinedIcon,
    component: TerritoryPerformance,
  },

  kpiAlerts: {
    title: "KPI / Alert Tracking",
    subtitle: "Active alerts and indicators",
    icon: NotificationsNoneOutlinedIcon,
    component: KPIAlertTrackingCard,
  },
  regionTracking: {
    title: "Region Tracking",
    subtitle: "Latest staff and patient messages",
    icon: ChatBubbleOutlineOutlinedIcon,
    component: RegionTrackingCard,
  },

  nationalPerformance: {
    title: "National Performance",
    subtitle: "Performance by territory vs benchmark",
    icon: LanguageOutlinedIcon,
    component: NationalPerformanceTile,
  },
  regionalTerritoryPerformance: {
    title: "Regional / Territory Performance",
    subtitle: "Territory progress in your region",
    icon: MapOutlinedIcon,
    component: RegionalTerritoryPerformanceTile,
  },
  insightPatientTrends: {
    title: "Patient Trends",
    subtitle: "Insight category breakdown",
    icon: InsightsOutlinedIcon,
    component: InsightPatientTrendsTile,
  },
  insightPhysicianBehavior: {
    title: "Physician Behavior",
    subtitle: "Insight category breakdown",
    icon: InsightsOutlinedIcon,
    component: InsightPhysicianBehaviorTile,
  },
  insightUtEngagement: {
    title: "UT Engagement",
    subtitle: "Insight category breakdown",
    icon: InsightsOutlinedIcon,
    component: InsightUtEngagementTile,
  },
  insightCompetitorDynamics: {
    title: "Competitor Dynamics",
    subtitle: "Insight category breakdown",
    icon: InsightsOutlinedIcon,
    component: InsightCompetitorDynamicsTile,
  },
  reachAndFrequency: {
    title: "Reach & Frequency",
    subtitle: "Engagement by decile tier",
    icon: QueryStatsOutlinedIcon,
    component: ReachAndFrequencyCard,
  },
  topYutrepiaWriters: {
    title: "Top Yutrepia Writers",
    subtitle: "Current vs prior month writers",
    icon: EmojiEventsOutlinedIcon,
    component: TopYutrepiaWritersCard,
  },
  treatmentRate: {
    title: TREATMENT_RATE_WIDGET_TEXT.title,
    switchTitle: TREATMENT_RATE_WIDGET_TEXT.switchTitle,
    subtitle: TREATMENT_RATE_WIDGET_TEXT.subtitle,
    icon: TimelineOutlinedIcon,
    component: TreatmentRateWidget,
  },
  hcpHcoAccountChanges: {
    title: "HCPs / HCOs Added & Removed This Week",
    menuTitle: "Weekly HCP/HCO Changes",
    subtitle: "Added & removed this week",
    icon: PersonAddAltOutlinedIcon,
    component: HcpHcoAccountChangesCard,
  },
  deNovo: {
    title: "De Novo UT Product Writers",
    subtitle: "HCPs who have written a referral for a UT therapy for the first time in the last 2 years",
    icon: FiberNewOutlinedIcon,
    component: DeNovoCard,
  },
  tyvasoDpiDosageDistribution: {
    title: "Tyvaso DPI Dosage Distribution",
    subtitle: "Patient distribution by prescribed dose",
    icon: MedicationOutlinedIcon,
    component: TyvasoDpiDosageDistributionCard,
  },
  // todo: uncomment this when the data is available
  // tyvasoDpiDosageNotification: {
  //   title: "Tyvaso DPI Dosage Notification",
  //   subtitle: "Dosage progression alerts",
  //   icon: NotificationsActiveOutlinedIcon,
  //   component: TyvasoDpiDosageNotificationCard,
  // },
};
